// import Request from 'gd-request';
import ApiIntegrationRequest from "../../api-request/api-intergration";

export default class ApiIntegrationGitlab {

    constructor() {}


    static installUrl() {
        // @ts-ignore
        return gdConfig.apiIntegration + 'gitlab/install/'+gd.companyId+ "?" + gd.auth.argsParams;
    }

    static moduleStatus() {
        return ApiIntegrationRequest.GET(this,'gitlab/module-status')
    }

    static disableRepository(repository:any) {
        return  ApiIntegrationRequest.DELETE(this,'gitlab/repository/'+repository.id)
    }

    static enableRepository(repository:any) {
        return ApiIntegrationRequest.POST(this,'gitlab/repository/'+repository.id, {})
    }


    static getRepositories() {
        return ApiIntegrationRequest.GET(this,'gitlab/repositories');
    }

    static getCommits(repositoryId:ID, branchName:string) {
        return ApiIntegrationRequest.GET(this,'gitlab/commits',{
            repositoryId    : repositoryId,
            branchName      : branchName
        });
    }

    static disableIntegration() {
        return  ApiIntegrationRequest.DELETE(this,'gitlab/module-status');
    }



}
